import React from 'react';
import PropTypes from 'prop-types';

import { H2 } from 'components/core/Typography';
import { Group, Section, Container } from 'components/core/Page';

import './StatePageIntro.scss';

export default function StatePageIntro({ state, welcome }) {
	return (
		<Container className="state-page-intro">
			<Section className="intro-section">
				<Section>
					<H2
						size="medium"
						className="state-page-title"
					>
						Welcome to {state}
					</H2>
				</Section>
				<Group>
					<div
						className="intro-copy"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html: welcome }}
					/>
				</Group>
			</Section>
		</Container>
	);
}

StatePageIntro.propTypes = {
	state: PropTypes.string.isRequired,
	welcome: PropTypes.string.isRequired,
};
